import { ExternalContextSource } from "@hex/common";
import { EmptyObject, ValueOf } from "type-fest";

import { ContextWorkbenchEditorFilesListNode } from "./contextWorkbenchEditorFilesListNode";

type AnyObject = Record<string, unknown>;

export type ContextWorkbenchFileNodeGroups<Node> =
  | ContextWorkbenchFileNodeGroups.FileNodeGroups<Node>
  | ContextWorkbenchFileNodeGroups.AsyncPlaceholder;

export namespace ContextWorkbenchFileNodeGroups {
  export const Type = {
    FileNodeGroups: "FileNodeGroups",
    AsyncPlaceholder: "AsyncPlaceholder",
  } as const;
  export type Type = ValueOf<typeof Type>;

  type _Base<
    TType extends ContextWorkbenchFileNodeGroups.Type,
    TProperties extends AnyObject = EmptyObject,
  > = {
    type: TType;
  } & TProperties;

  export type FileNodeGroup<Node> = {
    key: string;
    externalSource: ExternalContextSource | null;
    nodes: Node[];
  };

  export type FileNodeGroups<Node> = _Base<
    "FileNodeGroups",
    {
      groups: FileNodeGroup<Node>[];
    }
  >;

  export type AsyncPlaceholder = _Base<
    "AsyncPlaceholder",
    {
      node: ContextWorkbenchEditorFilesListNode.AsyncPlaceholder;
    }
  >;
}
